import * as React from 'react'

export const SvgSizeGuide = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} aria-hidden={true} {...props}>
    <path d="M15.536 1.393l7.07 7.071L8.465 22.607l-7.07-7.071L15.535 1.393zm0 2.829l-.884.884 1.414 1.414-1.06 1.06-1.415-1.414-1.06 1.061 2.828 2.828-1.06 1.061-2.83-2.828-1.06 1.06 1.414 1.415-1.06 1.06-1.415-1.414-1.06 1.06 2.828 2.83-1.06 1.06-2.829-2.829-1.06 1.061 1.414 1.414-1.061 1.06-1.414-1.413-.884.884 4.242 4.242L19.778 8.464l-4.242-4.242z" />
  </svg>
)
export default SvgSizeGuide
